import { useState, useRef } from 'react'
import * as PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import TextAreaField from '../../../FormLegacy/FormFieldsV2/TextAreaField'
import API from '../../../../api/api'
import Icon from '../../../Icons'

const AddNoteModal = ({ maintenanceId, handleCancel, getNotesAndActivities }) => {
  const { t } = useTranslation(['maintenance', 'common'])
  const [note, setNote] = useState('')
  const [errorMessage, setErrorMessage] = useState()
  const timeout = useRef(null)

  const addNote = () => {
    API.updateNote(maintenanceId, { note })
      .then(() => {
        getNotesAndActivities()
        handleCancel()
      })
      .catch(() => {
        setErrorMessage(t('maintenance:requestPreview.addNote.errors.couldNotAddNote'))
        timeout.current = setTimeout(() => {
          setErrorMessage(null)
        }, 2000)
      })
  }

  return (
    <div className="maintenance-request-add-note">
      <div className="maintenance-request-add-note__container">
        <div className="window-header">
          <div className="title">{t('maintenance:requestPreview.addNote.title')}</div>
          <div className="navi-button" onClick={() => handleCancel()}>
            <Icon icon="cross" />
          </div>
        </div>
        {errorMessage ? <div className="error-message">{errorMessage}</div> : null}
        <div className="main-view">
          <TextAreaField
            name={'description'}
            placeholder={t('maintenance:requestPreview.addNote.note.placeholder')}
            label={t('maintenance:requestPreview.addNote.note.label')}
            value={note}
            onChange={(e) => setNote(e.target.value)}
            maxLength="500"
            style={{ width: '100%' }}
          />
        </div>
        <div className="window-footer">
          <div className="footer-buttons">
            <button className={'button button-gray is-block'} onClick={() => handleCancel()}>
              {t('common:actions.cancel')}
            </button>
            <button
              disabled={!note}
              onClick={() => addNote()}
              className={'button button-primary is-block'}
            >
              {t('common:actions.save')}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

AddNoteModal.propTypes = {
  handleCancel: PropTypes.function,
  getNotesAndActivities: PropTypes.function,
  maintenanceId: PropTypes.number.required,
}

export default AddNoteModal
